import { render, staticRenderFns } from "./DnPieChart.vue?vue&type=template&id=ebfaba1e&scoped=true&"
import script from "./DnPieChart.vue?vue&type=script&lang=js&"
export * from "./DnPieChart.vue?vue&type=script&lang=js&"
import style0 from "./DnPieChart.vue?vue&type=style&index=0&id=ebfaba1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfaba1e",
  null
  
)

export default component.exports